import React from "react";
import StaffActivityPage from "Components/StaffActivity/StaffActivityPage";

const StaffActivityLog = () => {
  return (
    <div className="staff-activity-page">
      <StaffActivityPage />
    </div>
  );
};

export default StaffActivityLog;
